/**
 * 订阅发布
 */
export default class MultipleEvent {
  // 处理函数
  private handlers = {};

  /**
   * 监听指定函数
   * @param eventName {string} 事件名称
   * @param handleFn {function} 处理函数
   */
  $on(eventName: string, handleFn: Function) {
    (this.handlers[eventName] ??= []).push(handleFn);
  }
  /**
   * 触发指定事件
   * @param eventName {string} 事件名称
   * @param args {any} 传递处理函数参数
   */
  async $emit(eventName: string, ...args: any[]) {
    let result;
    try {
      const handleFnArr = this.handlers[eventName];

      for (const fn of handleFnArr) {
        const res = await fn(...args);
        res && (result = res);
      }
    } catch (e) {
      console.log(`${eventName} method repeat`);
    } finally {
      this.handlers[eventName] = [];
    }
    return result;
  }
}
